import script from "./ProfileAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileAccount.vue?vue&type=script&setup=true&lang=js"

import "./ProfileAccount.vue?vue&type=style&index=0&id=0d645b5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d645b5a"]])

export default __exports__